import { Observable } from "rxjs/internal/Observable";
import { catchError, map } from "rxjs/operators";
import { API_URL } from "../../enums/api.enums";
import HttpClient from "../http-client";
import { 
    ILoginRequest, 
    IRegisterRequest, 
    IChangePasswordRequest,
    IForgotPasswordRequest,
    IResetPasswordRequest,
    IRefreshTokenRequest
} from "../../common/login.interface";

export default class IdentityApi {
    static apiURL = API_URL;

    // Đăng nhập với username/email và mật khẩu
    static login(body: ILoginRequest): Observable<any> {
        const api = `${IdentityApi.apiURL.HOST}/auth/login`;
        return HttpClient.post(api, body).pipe(
            map(
                (res) => (res as any) || null,
                catchError((error) => new Observable())
            )
        );
    }

    // Đăng ký tài khoản mới
    static register(body: IRegisterRequest): Observable<any> {
        const api = `${IdentityApi.apiURL.HOST}/auth/register`;
        return HttpClient.post(api, body).pipe(
            map(
                (res) => (res as any) || null,
                catchError((error) => new Observable())
            )
        );
    }

    // Lấy thông tin profile user hiện tại
    static getUserProfile(): Observable<any> {
        const api = `${IdentityApi.apiURL.HOST}/users/my_profile`;
        return HttpClient.get(api).pipe(
            map(
                (res) => (res as any) || null,
                catchError((error) => new Observable())
            )
        );
    }

    // Đổi mật khẩu
    static changePassword(body: IChangePasswordRequest): Observable<any> {
        const api = `${IdentityApi.apiURL.HOST}/auth/change-password`;
        return HttpClient.put(api, body).pipe(
            map(
                (res) => (res as any) || null,
                catchError((error) => new Observable())
            )
        );
    }

    // Quên mật khẩu - gửi email reset
    static forgotPassword(body: IForgotPasswordRequest): Observable<any> {
        const api = `${IdentityApi.apiURL.HOST}/auth/forgot-password`;
        return HttpClient.post(api, body).pipe(
            map(
                (res) => (res as any) || null,
                catchError((error) => new Observable())
            )
        );
    }

    // Reset mật khẩu với token
    static resetPassword(body: IResetPasswordRequest): Observable<any> {
        const api = `${IdentityApi.apiURL.HOST}/auth/reset-password`;
        return HttpClient.post(api, body).pipe(
            map(
                (res) => (res as any) || null,
                catchError((error) => new Observable())
            )
        );
    }

    // Refresh token
    static refreshToken(body: IRefreshTokenRequest): Observable<any> {
        const api = `${IdentityApi.apiURL.HOST}/auth/refresh`;
        return HttpClient.post(api, body).pipe(
            map(
                (res) => (res as any) || null,
                catchError((error) => new Observable())
            )
        );
    }

    // Đăng nhập với Google
    static loginWithGoogle(body: { token: string }): Observable<any> {
        const api = `${IdentityApi.apiURL.HOST}/auth/google`;
        return HttpClient.post(api, body).pipe(
            map(
                (res) => (res as any) || null,
                catchError((error) => new Observable())
            )
        );
    }

    // Backwards compatibility methods
    static getUserInfo(token?: any): Observable<any> {
        return this.getUserProfile();
    }

    static handleRefreshToken(bodyrequest: any): Observable<any> {
        return this.refreshToken({ refreshToken: bodyrequest.refreshToken || bodyrequest.token });
    }

    // Typo fix for old method name
    static reqister(body: any): Observable<any> {
        return this.register(body);
    }
}
